(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ematrix-variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
const PRODUCT_SELECT_EVENT = 'shopify:product:select';
const LABELS = {
      'option::bakplate': 'Bakplate',
      'option::dekor': 'Dekor',
      'option::glass': 'Glass',
      'option::lys': 'Lys',
      'option::peistype': 'Peistype',
      'option::gasstype': 'Gasstype',
      'option::gasstype_medium': 'Gasstype/Medium',
      'option::styring': 'Styring',
      'option::hybrid_pro_light_hpl': 'Hybrid Pro Light (HPL)',
      'option::appstyring': 'Appstyring',
      'option::fjernkontroll': 'Fjernkontroll',
      'Option::symbio': 'Symbio',
      'DNO::ANSL_INNGANG': 'Ansl. inngang',
      'DNO::ANSL_UTGANG': 'Ansl. utgang',
      'DNO::BAKPLATE': 'Bakplate',
      'DNO::BEVEG_PIR': 'Beveg. PIR',
      'DNO::DEKOR': 'Dekor',
      'DNO::DIAMETER': 'Diameter',
      'DNO::DIMENSJON_DN': 'DN',
      'DNO::DRENERINGSHULL': 'Dreneringshull',
      'DNO::DRIFTSSPENNING': 'Driftsspenning',
      'DNO::FARGE_CONF': 'Farge',
      'DNO::GASSTYPE': 'Gasstype',
      'DNO::GJENGESTORRELSE': 'Gjengestørrelse',
      'DNO::GLASS': 'Glass',
      'DNO::INNGANGSTRYKK': 'Inngangstrykk',
      'DNO::LYS': 'Lys',
      'DNO::MALERTYPE': 'Målertype',
      'DNO::MATERIALE': 'Materiale',
      'DNO::PASSERTIL': 'Passer til',
      'DNO::PEISTYPE': 'Peistype',
      'DNO::PGLASS_PEISMODELL': 'Peismodell',
      'DNO::PGLASS_PLASSERING': 'Plassering',
      'DNO::PGLASS_TYPE': 'Type',
      'DNO::REGULATOR_CONF': 'Regulator',
      'DNO::SERIE_CONF': 'Serie',
      'DNO::SETTPUNKT': 'Settpunkt',
      'DNO::STROMFORB': 'Strømforbruk',
      'DNO::TRIM': 'Trim',
      'DNO::VEDK_PEISMODELL': 'Peismodell'
    };
    class EmatrixVariantPicker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.debugEnabled = this.dataset.debug === 'true';
        this.optionsRoot = this.querySelector('[data-ematrix-options]');
        this.message = this.querySelector('[data-ematrix-message]');
        this.configElement = this.querySelector('[data-ematrix-config]');
        this.sectionScope =
          this.closest('.shopify-section, dialog, product-card') ||
          this.closest('.product-details') ||
          this.closest('.product-information') ||
          this.parentElement ||
          document;
        this.requestGeneration = 0;
        this.responseCache = new Map();
        this.setPriceReady(false);
        if (this.dataset.ematrixBlocked === 'true') {
          this.disableProductForms();
          this.setMessage(
            this.message?.textContent?.trim() ||
              this.dataset.errorText ||
              'Dette produktet er ikke tilgjengelig for kjøp akkurat nå.',
            'error'
          );
          this.debug('Configuration product is blocked because no configuration products were found.');
          return;
        }
        this.debug('Connected', {
          pickerId: this.id,
          sectionId: this.dataset.sectionId,
          blockId: this.dataset.blockId,
          parentProductId: this.dataset.parentProductId,
          parentProductHandle: this.dataset.parentProductHandle,
          collectionHandle: this.dataset.collectionHandle,
          liquidCollectionProductsCount: Number(this.dataset.collectionProductsCount || 0),
          sectionScope: this.sectionScope
        });
        if (!this.optionsRoot || !this.configElement) {
          this.debug('Missing required picker elements', {
            optionsRoot: this.optionsRoot,
            configElement: this.configElement
          });
          return;
        }
        this.debug('Raw JSON script', {
          characterCount: this.configElement.textContent.length,
          preview: this.configElement.textContent.slice(0, 500)
        });
        try {
          this.config = JSON.parse(this.configElement.textContent);
        } catch (error) {
          this.setMessage(this.dataset.errorText, 'error');
          console.error('[Ematrix picker] Invalid configuration JSON.', error);
          return;
        }
        this.products = Array.isArray(this.config.products) ? this.config.products : [];
        this.mainProductTitle = this.config.parentProduct?.title || this.dataset.mainProductTitle || '';
        this.restoreMainProductTitle();
        this.debug('Parsed configuration', {
          parentProduct: this.config.parentProduct,
          mainProductTitle: this.mainProductTitle,
          collection: this.config.collection,
          jsonProductsCount: this.products.length,
          products: this.products
        });
        if (this.debugEnabled && this.products.length) {
          console.table(
            this.products.map((product) => ({
              productId: product.productId,
              handle: product.handle,
              variantId: product.variantId,
              available: product.available,
              optionDataCount: Array.isArray(product.optionData) ? product.optionData.length : 0,
              optionIdentifiers: (product.optionData || []).map((option) => option.identifier).join(', ')
            }))
          );
        }
        this.optionDefinitions = this.buildOptionDefinitions();
        if (
          this.products.length &&
          !this.optionDefinitions.length &&
          this.dataset.placeholderOptions === 'true'
        ) {
          this.applyPlaceholderOptions();
        } else {
          this.normalizeProducts();
        }
        this.debug('Active option definitions', {
          count: this.optionDefinitions.length,
          definitions: this.optionDefinitions,
          usingPlaceholderOptions: this.usingPlaceholderOptions === true
        });
        if (!this.products.length || !this.optionDefinitions.length) {
          this.debug('Initialization stopped: products or varying option definitions are missing', {
            productsCount: this.products.length,
            optionDefinitionsCount: this.optionDefinitions.length,
            allOptionData: this.products.map((product) => ({
              handle: product.handle,
              optionData: product.optionData
            }))
          });
          this.setMessage(this.dataset.noMatchText, 'error');
          this.disableProductForms();
          return;
        }
        this.renderSelectors();
        this.disableProductForms();
        this.restoreSelectionFromUrl();
        this.evaluateSelection({ updateUrl: true });
        window.__ematrixPickers = window.__ematrixPickers || [];
        if (!window.__ematrixPickers.includes(this)) window.__ematrixPickers.push(this);
        this.debug('Ready. Inspect this picker through window.__ematrixPickers', window.__ematrixPickers);
      }
      debug(label, value) {
        if (!this.debugEnabled) return;
        if (value === undefined) console.log(`[Ematrix picker: ${this.id}] ${label}`);
        else console.log(`[Ematrix picker: ${this.id}] ${label}`, value);
      }
      buildOptionDefinitions() {
const identifiers = [];
const keys = new Map();
        for (const product of this.products) {
          for (const option of product.optionData || []) {
            if (!option?.identifier || identifiers.includes(option.identifier)) continue;
            identifiers.push(option.identifier);
            keys.set(option.identifier, option.key || option.identifier.split('::').pop());
          }
        }
const definitions = identifiers
          .filter((identifier) => {
const values = new Set();
            for (const product of this.products) {
const option = (product.optionData || []).find((item) => item.identifier === identifier);
              if (option?.value !== undefined && option.value !== null && String(option.value).trim() !== '') {
                values.add(String(option.value));
              }
            }
            return values.size > 1;
          })
          .map((identifier) => ({
            identifier,
            key: keys.get(identifier),
            label: LABELS[identifier] || this.prettifyLabel(keys.get(identifier))
          }));
        this.debug('Option discovery', {
          discoveredIdentifiers: identifiers,
          valuesByIdentifier: Object.fromEntries(
            identifiers.map((identifier) => [
              identifier,
              this.products.map((product) => {
const option = (product.optionData || []).find((item) => item.identifier === identifier);
                return { handle: product.handle, value: option?.value ?? '' };
              })
            ])
          ),
          activeDefinitions: definitions
        });
        return definitions;
      }
      normalizeProducts() {
        for (const product of this.products) {
          product.options = this.optionDefinitions.map((definition) => {
const option = (product.optionData || []).find((item) => item.identifier === definition.identifier);
            return option?.value === undefined || option?.value === null ? '' : String(option.value);
          });
        }
      }
      applyPlaceholderOptions() {
        this.usingPlaceholderOptions = true;
        this.optionDefinitions = [
          {
            identifier: 'test::group',
            key: 'group',
            label: 'Testgruppe (midlertidig)'
          },
          {
            identifier: 'test::product',
            key: 'product',
            label: 'Testprodukt (midlertidig)'
          }
        ];
        this.products.forEach((product, index) => {
          product.options = [`Testgruppe ${(index % 2) + 1}`, product.title];
        });
        this.debug('PLACEHOLDER MODE ACTIVE: no real varying option metafields were found', {
          explanation:
            'Temporary options were generated from collection order and product title. Disable Placeholder options after adding real option metafields.',
          definitions: this.optionDefinitions,
          generatedProducts: this.products.map((product) => ({
            handle: product.handle,
            options: product.options
          }))
        });
        console.warn(
          `[Ematrix picker: ${this.id}] Placeholder options are active. These values are only for testing and do not come from product metafields.`
        );
      }
      prettifyLabel(value) {
        return String(value || 'Option')
          .replaceAll('_', ' ')
          .toLocaleLowerCase()
          .replace(/^./, (character) => character.toLocaleUpperCase());
      }
      parameterName(definition) {
const safeIdentifier = definition.identifier
          .toLocaleLowerCase()
          .replaceAll('::', '_')
          .replace(/[^a-z0-9_-]+/g, '_')
          .replace(/^_+|_+$/g, '');
        return `${this.dataset.parameterPrefix || 'config_'}${safeIdentifier}`;
      }
      renderSelectors() {
        this.optionsRoot.replaceChildren();
        this.selects = this.optionDefinitions.map((definition, index) => {
const wrapper = document.createElement('div');
          wrapper.className = 'ematrix-picker__option';
          wrapper.dataset.optionIndex = String(index);
          wrapper.dataset.optionIdentifier = definition.identifier;
const label = document.createElement('label');
          label.className = 'ematrix-picker__label';
          label.htmlFor = `${this.id}-Option-${index}`;
          label.textContent = definition.label;
const selectWrap = document.createElement('div');
          selectWrap.className = 'ematrix-picker__select-wrap';
const select = document.createElement('select');
          select.id = label.htmlFor;
          select.className = 'ematrix-picker__select';
          select.dataset.optionIndex = String(index);
          select.dataset.optionIdentifier = definition.identifier;
          select.addEventListener('change', () => this.handleChange(index));
const caret = document.createElement('span');
          caret.className = 'ematrix-picker__caret';
          caret.setAttribute('aria-hidden', 'true');
          selectWrap.append(select, caret);
          wrapper.append(label, selectWrap);
          this.optionsRoot.append(wrapper);
          return select;
        });
        this.refreshSelectors(0);
      }
      handleChange(changedIndex) {
        this.debug('Selector changed', {
          changedIndex,
          identifier: this.optionDefinitions[changedIndex]?.identifier,
          value: this.selects[changedIndex]?.value
        });
        for (let index = changedIndex + 1; index < this.selects.length; index += 1) {
          this.selects[index].value = '';
        }
        this.refreshSelectors(changedIndex + 1);
        this.evaluateSelection({ updateUrl: true });
      }
      refreshSelectors(startIndex) {
        for (let index = startIndex; index < this.selects.length; index += 1) {
const select = this.selects[index];
const wrapper = select.closest('.ematrix-picker__option');
const definition = this.optionDefinitions[index];
const previousValues = this.selects.slice(0, index).map((item) => item.value);
const previousComplete = previousValues.every(Boolean);
const currentValue = select.value;
const candidates = this.matchingProducts(previousValues.filter(Boolean));
const values = [];
          for (const product of candidates) {
const value = product.options[index];
            if (value && !values.includes(value)) values.push(value);
          }
          values.sort((left, right) => left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base' }));
          select.replaceChildren();
const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = `${this.dataset.selectText || 'Velg'} ${definition.label}`;
          select.append(placeholder);
          for (const value of values) {
const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            select.append(option);
          }
          if (currentValue && values.includes(currentValue)) select.value = currentValue;
const visible = index === 0 || previousComplete;
          wrapper.hidden = !visible;
          select.disabled = !visible;
          this.debug('Selector refreshed', {
            index,
            identifier: definition.identifier,
            previousValues,
            candidatesCount: candidates.length,
            values,
            selectedValue: select.value,
            visible,
            disabled: select.disabled
          });
        }
      }
      matchingProducts(selectedValues) {
        return this.products.filter((product) =>
          selectedValues.every((value, index) => String(product.options[index]) === String(value))
        );
      }
      selectedValues() {
        return this.selects.map((select) => select.value);
      }
      restoreSelectionFromUrl() {
const params = new URL(window.location.href).searchParams;
        this.debug('Restoring URL selection', {
          url: window.location.href,
          parameters: Object.fromEntries(params.entries())
        });
        for (let index = 0; index < this.optionDefinitions.length; index += 1) {
const definition = this.optionDefinitions[index];
const value = params.get(this.parameterName(definition));
const select = this.selects[index];
          if (!value || !Array.from(select.options).some((option) => option.value === value)) break;
          select.value = value;
          this.debug('Restored option from URL', {
            index,
            parameter: this.parameterName(definition),
            identifier: definition.identifier,
            value
          });
          this.refreshSelectors(index + 1);
        }
      }
      evaluateSelection({ updateUrl }) {
const selectedValues = this.selectedValues();
const isComplete = selectedValues.length > 0 && selectedValues.every(Boolean);
        this.debug('Evaluating selection', {
          selectedValues,
          isComplete,
          updateUrl
        });
        if (updateUrl) this.updateConfigurationUrl(null);
        if (!isComplete) {
          this.requestGeneration += 1;
          this.setPriceReady(false);
          this.disableProductForms();
          this.setMessage(this.dataset.incompleteText, 'incomplete');
          return;
        }
const matches = this.matchingProducts(selectedValues);
        this.debug('Matching result', {
          selectedValues,
          matchesCount: matches.length,
          matches: matches.map((product) => ({
            productId: product.productId,
            handle: product.handle,
            variantId: product.variantId,
            available: product.available,
            options: product.options
          }))
        });
        if (matches.length !== 1) {
          this.requestGeneration += 1;
          this.setPriceReady(false);
          this.disableProductForms();
          this.setMessage(this.dataset.noMatchText, 'error');
          return;
        }
const product = matches[0];
        if (!product.available) {
          this.requestGeneration += 1;
          this.setPriceReady(false);
          this.disableProductForms();
          this.setMessage(this.dataset.unavailableText, 'unavailable');
          if (updateUrl) this.updateConfigurationUrl(product);
          return;
        }
        if (updateUrl) this.updateConfigurationUrl(product);
        this.selectProduct(product);
      }
      updateConfigurationUrl(product) {
const url = new URL(window.location.href);
        url.searchParams.delete('variant');
        for (let index = 0; index < this.optionDefinitions.length; index += 1) {
const parameter = this.parameterName(this.optionDefinitions[index]);
const value = this.selects[index]?.value;
          if (value) url.searchParams.set(parameter, value);
          else url.searchParams.delete(parameter);
        }
        if (product?.handle) url.searchParams.set('configured_product', product.handle);
        else url.searchParams.delete('configured_product');
        window.history.replaceState(window.history.state, '', url);
        this.debug('URL updated without redirect', {
          configuredProduct: product?.handle || null,
          url: url.toString()
        });
      }
      async selectProduct(product) {
const generation = ++this.requestGeneration;
        this.setPriceReady(false);
        this.disableProductForms();
        this.setMessage(this.dataset.loadingText, 'loading');
let resolveSelection;
let rejectSelection;
const promise = new Promise((resolve, reject) => {
          resolveSelection = resolve;
          rejectSelection = reject;
        });
const event = new Event(PRODUCT_SELECT_EVENT, { bubbles: true });
        event.promise = promise;
        event.product = {
          id: product.productId,
          title: this.mainProductTitle || product.title,
          handle: product.handle
        };
        event.selectedOptions = this.optionDefinitions.map((definition, index) => ({
          name: definition.label,
          value: this.selects[index].value
        }));
        this.debug('Dispatching shopify:product:select', {
          product,
          selectedOptions: event.selectedOptions,
          eventTarget: this
        });
        this.dispatchEvent(event);
        try {
const html = await this.fetchProductSection(product);
          if (generation !== this.requestGeneration) {
            rejectSelection(new DOMException('Selection superseded.', 'AbortError'));
            return;
          }
const newProduct = {
            id: product.productId,
            title: this.mainProductTitle || product.title,
            handle: product.handle,
            url: product.url
          };
          resolveSelection({
            detail: {
              html,
              newProduct,
              productId: product.productId,
              resource: product.variant
            },
            variant: product.variant
          });
          this.debug('Product-select promise resolved', {
            newProduct,
            resource: product.variant,
            fetchedHtml: html
          });
          this.updateProductFormFallback(product);
          this.scheduleSelectedPresentation(generation);
          this.setMessage(this.mainProductTitle || product.title, 'selected');
        } catch (error) {
          rejectSelection(error);
          if (error?.name === 'AbortError') return;
          this.setPriceReady(false);
          this.updateProductFormFallback(product);
          this.setMessage(this.dataset.errorText, 'error');
          this.debug('Target product update failed', error);
          console.error('[Ematrix picker] Could not load target product section.', error);
        }
      }
      async fetchProductSection(product) {
const cacheKey = String(product.variantId);
        if (this.responseCache.has(cacheKey)) {
          this.debug('Using cached target HTML', { cacheKey, product });
          return this.responseCache.get(cacheKey).cloneNode(true);
        }
const url = new URL(product.url, window.location.origin);
        url.searchParams.set('variant', product.variantId);
        url.searchParams.set('section_id', this.dataset.sectionId);
        this.debug('Fetching target product section', url.toString());
let response = await fetch(url, {
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
let responseText = response.ok ? await response.text() : '';
        this.debug('Target section response', {
          ok: response.ok,
          status: response.status,
          characterCount: responseText.length
        });
        if (!responseText.trim()) {
          url.searchParams.delete('section_id');
          this.debug('Section HTML was empty; fetching the full target product page', url.toString());
          response = await fetch(url, {
            headers: {
              Accept: 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          responseText = response.ok ? await response.text() : '';
          this.debug('Full product response', {
            ok: response.ok,
            status: response.status,
            characterCount: responseText.length
          });
        }
        if (!response.ok || !responseText.trim()) {
          throw new Error(`Product request failed with ${response.status}.`);
        }
const documentFragment = new DOMParser().parseFromString(responseText, 'text/html');
        this.responseCache.set(cacheKey, documentFragment);
        return documentFragment.cloneNode(true);
      }
      productForms() {
        const sectionId = this.dataset.sectionId;
        const scopes = [];
        if (this.sectionScope) scopes.push(this.sectionScope);
        const productDetails = this.closest('.product-details');
        const productInformation = this.closest('.product-information');
        const shopifySection = this.closest('.shopify-section');
        if (productDetails && !scopes.includes(productDetails)) scopes.push(productDetails);
        if (productInformation && !scopes.includes(productInformation)) scopes.push(productInformation);
        if (shopifySection && !scopes.includes(shopifySection)) scopes.push(shopifySection);
        if (!scopes.includes(document)) scopes.push(document);
        const forms = [];
        for (const scope of scopes) {
          scope.querySelectorAll('product-form-component').forEach((form) => {
            if (!forms.includes(form)) forms.push(form);
          });
        }
        const matchingForms = forms.filter(
          (form) => !sectionId || !form.dataset.sectionId || form.dataset.sectionId === sectionId
        );
        this.debug('Horizon product forms found', {
          sectionId,
          formsInScope: forms.length,
          matchingForms: matchingForms.length,
          forms: matchingForms,
        });
        return matchingForms;
      }
      disableProductForms() {
        for (const form of this.productForms()) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = '';
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          for (const container of form.querySelectorAll('add-to-cart-component')) {
            if (typeof container.disable === 'function') container.disable();
            container.setAttribute('aria-disabled', 'true');
            container.dataset.ematrixDisabled = 'true';
          }
          for (const button of form.querySelectorAll('button[type="submit"], [name="add"]')) {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            button.classList.add('disabled');
          }
          for (const input of form.querySelectorAll('quantity-input input, input[name="quantity"]')) {
            input.disabled = true;
            input.setAttribute('aria-disabled', 'true');
          }
          for (const button of form.querySelectorAll('quantity-input button')) {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          }
        }
      }
      updateProductFormFallback(product) {
        for (const form of this.productForms()) {
          form.dataset.productId = product.productId;
          form.dataset.productUrl = product.url;
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = product.variantId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          for (const container of form.querySelectorAll('add-to-cart-component')) {
            if (typeof container.enable === 'function') container.enable();
            container.removeAttribute('aria-disabled');
            delete container.dataset.ematrixDisabled;
          }
          for (const button of form.querySelectorAll('button[type="submit"], [name="add"]')) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            button.classList.remove('disabled');
          }
          for (const input of form.querySelectorAll('quantity-input input, input[name="quantity"]')) {
            input.disabled = false;
            input.removeAttribute('aria-disabled');
          }
          for (const button of form.querySelectorAll('quantity-input button')) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          }
        }
      }
      setPriceReady(isReady) {
        this.dataset.priceReady = isReady ? 'true' : 'false';
        this.debug('Price visibility changed', { visible: isReady });
      }
      restoreMainProductTitle() {
        if (!this.mainProductTitle) return;
const titles = this.sectionScope.querySelectorAll(
          '.product-details h1, h1[data-product-title], [data-product-title] h1'
        );
        for (const title of titles) title.textContent = this.mainProductTitle;
        this.debug('Main product title restored', {
          title: this.mainProductTitle,
          elementsUpdated: titles.length
        });
      }
      scheduleSelectedPresentation(generation) {
const applyPresentation = () => {
          if (generation !== this.requestGeneration) return;
          this.restoreMainProductTitle();
          this.setPriceReady(true);
        };
        queueMicrotask(applyPresentation);
        requestAnimationFrame(applyPresentation);
      }
      setMessage(text, state) {
        if (!this.message) return;
        this.message.textContent = text || '';
        this.message.dataset.state = state;
      }
    }
    if (!customElements.get('ematrix-variant-picker')) {
      customElements.define('ematrix-variant-picker', EmatrixVariantPicker);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
